<template>
  <div class="address">
    <div class="addrlist">
      <van-row>
        <van-col span="20">
          <div class="f-12 c-gray">山东省 济南市 长清区 崮云湖街道 中建长清湖 知园52号楼<van-tag color="#605C6B">家</van-tag></div>
        </van-col>
        <van-col class="text-r" span="4">
          <img class="editpic" :src="img.edit">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="20">
          <div class="f-12 c-gray">山东省 济南市 长清区 崮云湖街道 中建长清湖 知园52号楼<van-tag color="#605C6B">公司</van-tag></div>
        </van-col>
        <van-col class="text-r" span="4">
          <img class="editpic" :src="img.edit">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="20">
          <div class="f-12 c-gray">山东省 济南市 长清区 崮云湖街道 中建长清湖 知园52号楼<van-tag color="#605C6B">学校</van-tag></div>
        </van-col>
        <van-col class="text-r" span="4">
          <img class="editpic" :src="img.edit">
        </van-col>
      </van-row>
    </div>
    <div class="btn-box">
      <van-button color="#605C6B" size="large" :to="{name: 'LexusCreateAddr'}">创建地址</van-button>
    </div>
  </div>
</template>
<script>
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Row, Col,Button,Tag,List } from 'vant';
  export default {
    data () {
      return {
        img:{
          edit: require('../../../assets/img/lexus/edit.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      var params={
        event_code: '我的地址',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/MyAddress.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {

    },
    components:{
      [List.name]: List,
      [Row.name]: Row,
      [Col.name]: Col,
      [Button.name]:Button,
      [Tag .name]:Tag 
    }
  }
</script>

<style lang="scss">
.address{
  padding: 20px;
  .addrlist{
    margin-bottom: 80px;
  }
  .van-row{
    padding: 20px 0;
    line-height: 2;
    border-bottom:1px solid #f8f8f8;
    .van-tag{
      height: 15px;
      width: 30px;
      text-align: center;
      margin-left: 5px;
    }
    .editpic{
      width: 13px;
      height: 15px;
    }
  }
  .btn-box{
    width: 90%;
    bottom: 20px;
    position: fixed;
  }
}
</style>
